module.exports = __webpack_public_path__ + "img/Polygon 1.f3fb5d52.svg";